<template>
  <div class="col-12 d-flex justify-space-between">
    <v-card v-for="(item, index) in reviews" :key="`review_transferTable_${index}`" class="col-5" height="350">
      <v-card-title class="d-flex justify-center">
        <span> {{ item.label }} </span>
      </v-card-title>
      <v-card-text class="d-flex flex-column align-start">
        <div>
          <span class="font-weight-bold">Nom de la session: </span>
          <span>{{ item.session.name }}</span>
        </div>
        <div>
          <span class="font-weight-bold">Début de la session: </span>
          <span>{{ item.session.first_session_date }}</span>
        </div>
        <div>
          <span class="font-weight-bold">Fin de la session: </span>
          <span>{{ item.session.last_session_date }}</span>
        </div>
        <div>
          <span class="font-weight-bold">Numéro de participant: </span>
          <span> {{ item.session.slotsFilled }} </span>
        </div>
        <div>
          <span class="font-weight-bold">Période prenant effet: </span>
          <span> {{ item.session.date }}</span>
        </div>
        <div v-if="item.contractProperties" class="d-flex flex-column align-start mt-4">
          <div>
            <span class="font-weight-bold">Nouveau produit: </span>
            <span> {{ item.contractProperties.product }} </span>
          </div>
          <div>
            <span class="font-weight-bold">Nouveau tarif: </span>
            <span> {{ item.contractProperties.tariff }} </span>
          </div>
          <div>
            <span class="font-weight-bold">Nouvelle période: </span>
            <span> {{ item.contractProperties.period.name }} </span>
          </div>
          <div>
            <span class="font-weight-bold">Nouvelle catégorie de prix: </span>
            <span> {{ item.contractProperties.priceCategory }} </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    reviews: {
      type: Array,
      default: () => []
    }
  }
};
</script>
